import React from 'react'

export default function FileCheck(props) {
  return (
    <svg width={38} height={42} viewBox="0 0 38 42" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M3 1h18l16 16v22a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2zm12 24l3 3 5-5"
          stroke="#57B560"
          strokeWidth={2}
          strokeLinejoin="round"
        />
        <path d="M21 2l15 15H23a2 2 0 01-2-2V2z" fill="#57B560" />
      </g>
    </svg>
  )
}
